import { render, staticRenderFns } from "./RetrievePassword.vue?vue&type=template&id=156d662f&scoped=true"
import script from "./RetrievePassword.vue?vue&type=script&lang=js"
export * from "./RetrievePassword.vue?vue&type=script&lang=js"
import style0 from "./RetrievePassword.vue?vue&type=style&index=0&id=156d662f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156d662f",
  null
  
)

export default component.exports